<template>
  <div>
    <span v-show="loading" class="spinner-border spinner-border-xl"></span>
    <div v-show="documentList.length && !loading" class="card card-fluid pb-3">
      <div class="card-header">Čaka na potrjevanje</div>

      <div class="accordion" role="tablist">
        <b-card
          no-body
          class="mb-1"
          v-for="dokumentTipId in documentTipIdList"
          :key="dokumentTipId"
        >
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button
              block
              v-b-toggle="'collapsePannel' + dokumentTipId.toString()"
              variant="info"
            >{{ documentList.filter(i => i.dokumentTipId == dokumentTipId)[0].dokumentTipSifra }}</b-button>
          </b-card-header>
          <b-collapse :id="'collapsePannel' + dokumentTipId.toString()" accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <div
                v-for="document in documentList.filter(i => i.dokumentTipId == dokumentTipId)"
                :key="document.dokumentId"
                class="list-group list-group-flush"
              >
                <div class="list-group-item">
                  <div class="list-group-item-figure">
                    <router-link
                      :to="{ name: 'DocumentPage', params: { id: document.dokumentId.toString() }}"
                      class="tile tile-lg bg-purple"
                    >
                      <b-icon icon="check2-square" size="lg"></b-icon>
                    </router-link>
                  </div>
                  <div class="list-group-item-body">
                    <h5 class="card-title">
                      <router-link
                        :to="{ name: 'DocumentPage', params: { id: document.dokumentId.toString() }}"
                      >{{ document.dokumentTipSifra}} - ID{{ document.dokumentId}}</router-link>
                    </h5>
                    <p
                      class="card-subtitle text-muted mb-1"
                    >Status {{ document.dokumentStatusSifra}}</p>
                  </div>
                </div>
              </div>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
    </div>
    <div v-show="documentKomentarList.length && !loading" class="card card-fluid pb-3">
      <div class="card-header">Čaka na komentar</div>
      <div class="accordion" role="tablist">
          <b-card no-body
                  class="mb-1"
                  v-for="dokumentTipId in documentKomentarTipIdList"
                  :key="dokumentTipId">
              <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button block
                            v-b-toggle="'collapsePannelKomentar' + dokumentTipId.toString()"
                            variant="info">{{ documentKomentarList.filter(i => i.dokumentTipId == dokumentTipId)[0].dokumentTipSifra }}</b-button>
              </b-card-header>
              <b-collapse :id="'collapsePannelKomentar' + dokumentTipId.toString()" accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                      <div v-for="document in documentKomentarList.filter(i => i.dokumentTipId == dokumentTipId)"
                           :key="document.dokumentId"
                           class="list-group list-group-flush">
                          <div class="list-group-item">
                              <div class="list-group-item-figure">
                                  <router-link :to="{ name: 'DocumentPage', params: { id: document.dokumentId.toString() }}"
                                               class="tile tile-lg bg-purple">
                                      <b-icon icon="chat" size="lg"></b-icon>
                                  </router-link>
                              </div>
                              <div class="list-group-item-body">
                                  <h5 class="card-title">
                                      <router-link :to="{ name: 'DocumentPage', params: { id: document.dokumentId.toString() }}">{{ document.dokumentTipSifra}} - ID{{ document.dokumentId}}</router-link>
                                  </h5>
                                  <p class="card-subtitle text-muted mb-1">Status Čaka na komentar</p>
                              </div>
                          </div>
                      </div>
                  </b-card-body>
              </b-collapse>
          </b-card>
      </div>
    </div>
    <div class="all-done" v-show="!documentList.length && !documentKomentarList.length && !loading">
        <h1 style="font-size: 6rem;">
            <b-icon icon="check2-square" size="lg"></b-icon>
        </h1>
        <h3>Ni več čakajočih dokumentov</h3>
        <b-button pill variant="primary" @click="loadDocumentGrid" id="btnRefresh"><b-icon icon="arrow-clockwise"></b-icon> Osveži</b-button>

    </div>
    <div v-if="message" class="alert alert-danger" role="alert">{{message}}</div>
  </div>
</template>

<script>
import DokumentService from "../services/dokument.service";

export default {
  name: "DocumentGrid",
  props: {
    msg: String,
  },
  data() {
    return {
      documentList: [],
      documentTipIdList: [],
      documentKomentarList: [],
      documentKomentarTipIdList: [],
      uporabnik: {
        userName: "",
        password: "",
      },
      message: "",
      loading: false,
    };
  },
  methods: {
    loadDocumentGrid() {
      this.loading = true;
      DokumentService.getGrid().then(
        (response) => {
          this.documentList = response.data.potrjevanjeList;
          this.documentKomentarList = response.data.komentarList;
          this.documentTipIdList = [
            ...new Set(
              response.data.potrjevanjeList.map((i) => i.dokumentTipId)
            ),
          ];
          this.documentKomentarTipIdList = [
            ...new Set(response.data.komentarList.map((i) => i.dokumentTipId)),
          ];

          this.loading = false;
        },
        () => {
          this.loading = false;
          this.message =
            "Prišlo je do napake! Poskusite ponovno čez nekaj minut.";
        }
      );
    },
  },
  mounted() {
    this.loadDocumentGrid();
  },
};
</script>

<style scoped>
.list-group-item-body {
  text-align: left;
}

.all-done {
  color: #c3949f;
  padding-top: 30%;
}

.modal-content {
  height: 98vh !important;
}

#btnRefresh {
    margin-top: 1rem;
    border-color: #c3949f;
    background-color: #c3949f;
}
</style>
